import React, { useEffect, useRef, useState } from 'react';
import './DateRangeFilter.css';
import { FaChevronDown } from 'react-icons/fa';

const DateRangeFilter = ({ dateFrom, dateTo, onApply }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [pendingDateFrom, setPendingDateFrom] = useState(dateFrom);
    const [pendingDateTo, setPendingDateTo] = useState(dateTo);
    const panelRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleOpen = () => {
        setPendingDateFrom(dateFrom);
        setPendingDateTo(dateTo);
        setIsOpen(true);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handleApply = () => {
        onApply({
            date_from: pendingDateFrom,
            date_to: pendingDateTo
        });
        setIsOpen(false);
    };

    const triggerLabel = (!dateFrom && !dateTo) ? 'Select Date Range' : `${new Date(dateFrom)?.toLocaleDateString("en-GB", {
        year: "2-digit",
        month: 'short',
        day: "2-digit"
    })} - ${new Date(dateTo)?.toLocaleDateString("en-GB", {
        year: "2-digit",
        month: 'short',
        day: "2-digit"
    })}`;

    return (
        <div className="date-range-filter" ref={panelRef}>
            <button className="date-range-trigger" onClick={handleOpen}>
                {triggerLabel}
                <FaChevronDown size={14} />
            </button>

            {isOpen && (
                <div className="date-range-panel">
                    <div className="date-range-field">
                        <label>From</label>
                        <input
                            type="date"
                            value={pendingDateFrom}
                            max={pendingDateTo}
                            onChange={(e) => setPendingDateFrom(e.target.value)}
                        />
                    </div>
                    <div className="date-range-field">
                        <label>To</label>
                        <input
                            type="date"
                            value={pendingDateTo}
                            min={pendingDateFrom}
                            onChange={(e) => setPendingDateTo(e.target.value)}
                        />
                    </div>

                    <div className="date-range-actions">
                        <button className="date-range-cancel-btn" onClick={handleCancel} type="button">
                            Cancel
                        </button>
                        <button className="date-range-apply-btn" onClick={handleApply}>
                            Apply
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateRangeFilter;